<!-- paypal-settings.component.html -->
<div class="container">
  <br/>
  <h5><i class="fas fa-wallet"></i> Cài Đặt PayPal</h5>

    <form [formGroup]="paypalForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="clientId">ID Khách Hàng</label>
        <input id="clientId" formControlName="clientId" class="form-control" />
      </div>
  
      <div class="form-group">
        <label for="clientSecret">Mã Bí Mật Khách Hàng</label>
        <input id="clientSecret" formControlName="clientSecret" class="form-control" />
      </div>
  
      <div class="form-group">
        <label for="mode">Chế Độ (sandbox/live)</label>
        <input id="mode" formControlName="mode" class="form-control" />
      </div>
  
      <button type="submit" class="btn btn-outline-primary" [disabled]="!paypalForm.valid">
        Cập Nhật
      </button>
    </form>
  
    <!-- Success Message -->
    <div *ngIf="successMessage" class="alert alert-outline-success mt-2">
      {{ successMessage }}
    </div>
  
    <!-- Error Message -->
    <!-- <div *ngIf="errorMessage" class="alert alert-danger mt-2">
      {{ errorMessage }}
    </div> -->
</div>
